<h3>{{ 'common.labels.generalCollateral' | transloco }}</h3>

@if (uiConfiguration.showCollateralHistoryButton) {
  <div class="padding-25">
    <lib-general-collateral-history-expandable [order]="order"></lib-general-collateral-history-expandable>
  </div>
}

<form [formGroup]="generalCollateralDetails" class="padding">
  @if (uiConfiguration.showSecurityInterest) {
    <div class="flex-container margin-bottom-15">
      <mat-checkbox class="flex-item" data-testid="security-interest-checkbox" formControlName="securityInterest">
        {{ 'orders.theSecurityInterestIsTakenIn' | transloco }}
      </mat-checkbox>
    </div>
  }

  @if (uiConfiguration.showSecurityInterestExceptFor) {
    <div class="flex-container margin-bottom-15">
      <mat-checkbox class="flex-item" data-testid="security-interest-except-for-checkbox" formControlName="securityInterestExceptFor">
        {{ 'orders.theSecurityInterestIsTakenIn2' | transloco }}
      </mat-checkbox>
    </div>
  }

  @if (uiConfiguration.showReusableGeneralCollateral && reusableGeneralCollateral.length > 0) {
    <div
      class="flex-container vertical-align">
      <mat-form-field class="flex-item-6" appearance="outline">
        <mat-select [placeholder]="'orders.reusableCollateral' | transloco"
          [(ngModel)]="this.selectedReusableGeneralCollateralID"
          [ngModelOptions]="{standalone: true}" data-testid="reusable-collateral-dropdown">
          @for (collateral of reusableGeneralCollateral; track collateral; let i = $index) {
            <mat-option [value]="collateral.id!"
              [attr.data-testid]="'reuasable-collateral-option-' + i">
              {{ collateral.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button mat-raised-button
        (click)="populateReusableGeneralCollateral()"
        [disabled]="!selectedReusableGeneralCollateralID"
        color="primary"
        class="margin-left-25 flex-item reusable-collateral-button"
        [attr.aria-label]="'orders.saveReusableCollateralButton' | transloco"
        data-testid="add-reusable-collateral-button">
        {{ 'orders.useReusableCollateral' | transloco }}
      </button>
    </div>
  }

  @if (uiConfiguration.showCollateralValue) {
    <div class="flex-container">
      <div class="validated-form-field-container flex-container">
        <mat-form-field class="flex-item form-field" appearance="outline">
          <mat-label>{{ uiConfiguration.collateralValueTitle | uiText }}</mat-label>
          <textarea [libAutoCapitalize]="uiConfiguration.autoCapitalizeFields" matInput data-testid="general-collateral-field" formControlName="collateralValue"
           [rows]="textareaRows"></textarea>
        </mat-form-field>
        <lib-error-bubble [control]="generalCollateralDetails.controls['collateralValue']"
        [message]="collateralValueError$"></lib-error-bubble>
      </div>
    </div>
  }

  @if (uiConfiguration.showCollateralToAdd) {
    <div class="flex-container">
      <div class="validated-form-field-container flex-container">
        <mat-form-field class="flex-item form-field" appearance="outline">
          <mat-label>{{ 'orders.generalCollateralToAdd' | transloco }}</mat-label>
          <textarea matInput [libAutoCapitalize]="uiConfiguration.autoCapitalizeFields" data-testid="general-collateral-to-add-field" formControlName="collateralToAdd"
          [rows]="textareaRows"></textarea>
        </mat-form-field>
        <lib-error-bubble [control]="generalCollateralDetails.controls['collateralToAdd']"
        [message]="collateralToAddError$"></lib-error-bubble>
      </div>
    </div>
  }

  @if (uiConfiguration.showCollateralToRemove) {
    <div class="flex-container">
      <div class="validated-form-field-container flex-container">
        <mat-form-field class="flex-item form-field" appearance="outline">
          <mat-label>{{ 'orders.generalCollateralToRemove' | transloco }}</mat-label>
          <textarea matInput [libAutoCapitalize]="uiConfiguration.autoCapitalizeFields" data-testid="general-collateral-to-remove-field" formControlName="collateralToRemove"
          [rows]="textareaRows"></textarea>
        </mat-form-field>
        <lib-error-bubble [control]="generalCollateralDetails.controls['collateralToRemove']"
        [message]="collateralToRemoveError$"></lib-error-bubble>
      </div>
    </div>
  }
</form>